import React from 'react';
import { PlusIcon } from 'lucide-react';
import { faq } from '../data/faq';
export function FaqSection() {
  return <section id="faq" aria-labelledby="faq-heading" className="py-16 lg:py-28 bg-[#0d1225] scroll-mt-16" data-id="element-94" data-mp="1plctsa7qeiz4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95" data-mp="1bltzak7uf65a">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-96" data-mp="1gj3mrubo97qh">
          <div className="lg:col-span-4" data-id="element-97" data-mp="1glpvvye7nvat">
            <h2 id="faq-heading" className="text-3xl lg:text-4xl font-bold text-white mb-5" data-id="element-98" data-mp="248xyg8k98q95">
              Häufige Fragen zur Close CRM Agentur
            </h2>
            <p className="text-gray-400 leading-relaxed" data-id="element-99" data-mp="28cm7kvojbtwi">
              Kosten, Dauer, Agenturwechsel und Support – die Fragen, die wir
              im Erstgespräch am häufigsten hören.
            </p>
          </div>

          <div className="lg:col-span-8 divide-y divide-white/10 border-y border-white/10" data-id="element-100" data-mp="2n8bxv60r6t71">
            {faq.map(item => <details key={item.question} className="group py-2" data-id="element-101" data-mp="2rzty1ruycpqy">
                <summary className="flex items-center justify-between gap-6 py-4 cursor-pointer list-none [&::-webkit-details-marker]:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ff6b35] rounded" data-id="element-102" data-mp="14v0ueylnzy8a">
                  <h3 className="text-lg font-semibold text-white" data-id="element-103" data-mp="1eldbggu9t99o">{item.question}</h3>
                  <PlusIcon className="w-5 h-5 text-[#ff6b35] flex-shrink-0 transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-104" data-mp="19tvavtw5tap8" />
                </summary>
                <p className="pb-5 pr-10 text-gray-400 leading-relaxed" data-id="element-105" data-mp="1jjojqn4x3bps">{item.answer}</p>
              </details>)}
          </div>
        </div>
      </div>
    </section>;
}